import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Accordion, AccordionTab } from "primereact/accordion";
import "primeicons/primeicons.css";
import { ApiEndpoints, Constants } from "../../../constants/appConstants";
import { useLocation, useSearchParams } from "react-router";
import httpService from "../../../services/httpService";
import { Dialog } from "primereact/dialog";
//import { useNavigate } from 'react-router';
import "./PfpProviderProfileComponent.scss";
import { Tooltip } from "primereact/tooltip";
import { Badge } from "primereact/badge";
import {
  alphaNumericSort,
  PerformanceArea,
  ReviewRquest,
  Standard,
  TierQuestions,
  Status,
  ReviewStatusCode,
  Comment,
  TierCode,
  ReviewType,
} from "./models";
import StandardsDetailsComponent from "./StandardsDetailsComponent";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { useAuthContext } from "../../../Context/AuthContext";
import CommentsSidebar from "./CommentsSidebar";
import { useAppContext } from "../../../Context";
import MultipartFileUploadComponent from "../../FileUpload/MultpartFileUploadComponent";

const PfpRHProviderProfileComponent: React.FC = () => {
  //const navigate = useNavigate()
  const { appUser } = useAuthContext();
  const [uploadStatus, setUploadStatus] = useState<string | null>(null);
  const location = useLocation();
  const [provider, setSelectedProvider] = useState<any>({});
  //const [providerDetails, setProviderDetails] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [fileUploaded, setFileUploaded] = useState<boolean>(false); // New state to track file upload status
  //const [activeIndex] = useState<number[]>([0, 1, 2]);
  const [status, setStatus] = useState<Status[]>([]);
  const [performanceAreas, setPerformanceAreas] = useState<PerformanceArea[]>(
    []
  ); // New state to hold performance areas
  const [visible, setVisible] = useState(false);
  const [reviweResponses, setReviewResponses] = useState<ReviewRquest[]>([]);
  const [selectedStatus, setSelectedStatus] = useState<
    Status | null | undefined
  >(null);
  const [isActiveReview, setIsActiveReview] = useState(false);
  const [appliedTierId, setAppliedTierId] = useState<number>(0);
  const [allStatues, setAllStatues] = useState<Status[]>([]);
  const [isStatusLoaded, setIsStatusLoaded] = useState<boolean>(false);
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [commentProviderMPI, setCommentProviderMPI] = useState(
    location?.state?.provider?.mpi
  );
  const [commentMeasureNumber, setCommentMeasureNumber] = useState("");
  const [commentMeasureId, setCommentMeasureId] = useState(0);
  const [commentLevel, setCommentLevel] = useState("");
  const [providerId, setProviderId] = useState(0);
  const [allCommentData, setAllCommentData] = useState<Comment[]>([]);
  const { reviewYear } = useAppContext();
    const [searchParams] = useSearchParams();
  //const [attestationFile, setAttestationFile] = useState<any>(null);
const getAllEvaluationStatuses = () => {
          const status = [
            { code: "a", name: "Approved" },
            { code: "null", name: "Not reviewed" },
            { code: "na", name: "Not approved" },
          ];
      return status;
  }
  // Initialize provider from location
  useEffect(() => {
    const mpiId = searchParams.get('mpi');
    if (reviewYear && !mpiId) {
      const _provider = location.state?.provider;
      if (_provider) {
        console.log("Provider:", _provider);
        fetchProviderDetails(_provider?.mpi);
        fetchAllCommentsForProvider(_provider?.mpi);
        setProviderId(_provider?.providerId);
        setCommentProviderMPI(_provider?.mpi);
        setCommentMeasureNumber(_provider?.mpi);

        setCommentMeasureId(0);
        setCommentLevel("provider");
        //fetchProviderAttestationFileDetails(_provider?.mpi);
        fetchPerformanceStandardsMeasuresInfo(
          _provider?.mpi,
          _provider?.appliedTier
        );
      } // Fetch performance areas and related data
    }
  }, [location.state?.provider, reviewYear]);
  //onload events

  useEffect(() => {
    const mpiId = searchParams.get('mpi');

    if (reviewYear && mpiId) {
      const mpi = Number(mpiId)
      fetchProviderDetails(mpi);
      fetchAllCommentsForProvider(mpiId);
      setCommentProviderMPI(mpi);
      setCommentMeasureNumber(mpiId);

      setCommentMeasureId(0);

      setCommentLevel("provider");
      //fetchProviderAttestationFileDetails(_provider?.mpi);

    } // Fetch performance areas and related data
  }, [location.state?.provider, reviewYear]);



  useEffect(() => {
    if (provider) {
      setProviderId(provider?.providerId);

      fetchPerformanceStandardsMeasuresInfo(
        provider?.mpi,
        provider?.appliedTier
      );
    }
  }, [provider]);


  useEffect(() => {
    isActiveReviewCycle();
    getAllStatus();
  }, []);

  useEffect(() => {
    if (provider.providerId && isStatusLoaded) {
      updateStatusDropDown();
    }
  }, [provider, isStatusLoaded]);

  useEffect(() => {
    if (providerId > 0) {
      updatePerformanceAreasForComments(0, true);
    }
  }, [allCommentData, performanceAreas]);

  const updatePerformanceAreasForComments = (
    measureId: number,
    isCommentsLoaded: boolean = false
  ) => {
    if (performanceAreas.length > 0 && measureId > 0) {
      setPerformanceAreas((prevPerformanceAreas) =>
        prevPerformanceAreas.map((area) => ({
          ...area,
          standards: area.standards.map((standard) => ({
            ...standard,
            measures: standard.measures.map((measure) => {
              if (measure.measureId === measureId) {
                // Update measure.isCommentsAvailable
                return { ...measure, isCommentsAvailable: true };
              }
              return measure; // No match, return the original measure
            }),
          })),
        }))
      );
    } else if (isCommentsLoaded) {
      setPerformanceAreas((prevPerformanceAreas) =>
        prevPerformanceAreas.map((area) => ({
          ...area,
          standards: area.standards.map((standard) => ({
            ...standard,
            measures: standard.measures.map((measure) => {
              if (
                allCommentData.some((x) => x.measureId == measure.measureId)
              ) {
                // Update measure.isCommentsAvailable
                return { ...measure, isCommentsAvailable: true };
              }
              return measure; // No match, return the original measure
            }),
          })),
        }))
      );
    }
  };

  const isActiveReviewCycle = () => {
    httpService
      .get(ApiEndpoints.IsActiveReview)
      .then((response: any) => {
        setIsActiveReview(response?.data);
      })
      .catch((error: any) => {
        console.log("Error: ", error);
      });
  };

  // Fetch files and provider details once provider is set

  const updateStatusDropDown = () => {
    let requiredStatuses: Status[] = [];

    if (
      provider.reviewStatusCode?.toLowerCase() ===
        ReviewStatusCode.NotStarted?.toLowerCase() ||
      provider.reviewStatusId === 0 ||
      !provider.reviewStatusId
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.NotStarted.toLowerCase() ||
          status.statusCode?.toLowerCase() ==
            ReviewStatusCode.InPrimaryReview?.toLowerCase()
      );
    } else if (
      provider.reviewStatusCode?.toLowerCase() ===
      ReviewStatusCode.InPrimaryReview.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.InPrimaryReview.toLowerCase() ||
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.DocumentsNeeded?.toLowerCase() ||
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.InPeerReview?.toLowerCase()
      );
    } else if (
      provider.reviewStatusCode?.toLowerCase() ===
      ReviewStatusCode.InPeerReview.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.InPeerReview.toLowerCase() ||
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.DocumentsNeeded?.toLowerCase() ||
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ReviewCompleted?.toLowerCase()
      );
    } else if (
      provider.reviewStatusCode?.toLowerCase() ===
      ReviewStatusCode.InPeerReview.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.InPeerReview.toLowerCase() ||
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.DocumentsNeeded?.toLowerCase() ||
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.ReviewCompleted?.toLowerCase()
      );
    } else if (
      provider.reviewStatusCode?.toLowerCase() ===
      ReviewStatusCode.DocumentsNeeded.toLowerCase()
    ) {
      requiredStatuses = allStatues.filter(
        (status) =>
          status.statusCode?.toLowerCase() ===
            ReviewStatusCode.DocumentsNeeded.toLowerCase() ||
          (provider.reviewType?.toLowerCase() != ReviewType.SecondaryReview &&
            status.statusCode?.toLowerCase() ===
              ReviewStatusCode.InPeerReview?.toLowerCase()) ||
          (provider.reviewType?.toLowerCase() == ReviewType.SecondaryReview &&
            status.statusCode?.toLowerCase() ===
              ReviewStatusCode.ReviewCompleted?.toLowerCase())
      );
    } else {
      requiredStatuses = allStatues.filter(
        (status) => status.statusId === provider.reviewStatusId
      );
    }

    if (requiredStatuses.length === 0) {
      console.log("unable to find the status", provider);
      console.log("unable to find the status from all statuses", allStatues);
    }
    //if the user tier is un assigned don't display review completed status
    if (
      provider.currentTierCode?.toLowerCase() ===
      TierCode.UnAssigned.toLowerCase()
    ) {
      requiredStatuses = requiredStatuses.filter(
        (status) =>
          status.statusCode?.toLowerCase() !==
          ReviewStatusCode.ReviewCompleted.toLowerCase()
      );
    }

    setStatus(requiredStatuses);
    if (
      provider.reviewStatusCode?.toLowerCase() ==
        ReviewStatusCode.NotStarted.toLowerCase() ||
      provider.reviewStatusId == 0
    ) {
      setSelectedStatus(
        allStatues.find(
          (status) =>
            status.statusCode?.toLowerCase() ===
            ReviewStatusCode.NotStarted.toLowerCase()
        )
      );
    } else {
      setSelectedStatus(
        allStatues.find(
          (status) =>
            status.statusCode?.toLowerCase() ==
            provider.reviewStatusCode?.toLowerCase()
        )
      );
    }
  };

   const hasUnReviewedMeasures = (): boolean => {
    const hasApprovedMeasures = performanceAreas.reduce((acc, area) => {
      return (
        acc +
        area.standards.reduce((acc, standard) => {
          return (
            acc +
            standard.measures.filter((measure) => measure.reviewResponse === null || measure.reviewResponse.toLowerCase() === 'null').length
          );
        }, 0)
      );
    }, 0);
    return hasApprovedMeasures > 0;
  };

  const getAllStatus = () => {
    httpService
      .get<Status[]>(`${ApiEndpoints.GetStatus}?providerType=${Constants.RSKey}`)
      .then((response) => {
        setAllStatues(response.data);
        setIsStatusLoaded(true);
      })
      .catch((error) => {
        console.error("Error fetching tiers:", error);
      });
  };

  const setReviewStatus = (e: Status) => {
    httpService
      .post(ApiEndpoints.SetReviewStatus, {
        ProviderId: provider.providerId,
        StatusId: e.statusId,
        reviewerName: appUser?.name ?? appUser?.email,
        ReviewYear: reviewYear,
        MpiId: provider.mpi,
      })
      .then((response: any) => {
        if (response.status === 200) {
          setSelectedStatus(e);
          //setProviderDetails({ ...provider, reviewStatus: e.statusName })
          console.log("allStatues:", allStatues);

          let currentReviewType =
            e.statusCode.toUpperCase() === ReviewStatusCode.InPrimaryReview
              ? ReviewType.PrimaryReview
              : e.statusCode.toUpperCase() === ReviewStatusCode.InPeerReview
              ? ReviewType.SecondaryReview
              : provider.reviewType;

          setSelectedProvider({
            ...provider,
            reviewStatusCode: e.statusCode,
            reviewStatus: e.statusName,
            reviewStatusId: e.statusId,
            reviewType: currentReviewType,
          });
          // Invoking ReviewStatusSync in Intake Portal - configurable via environment variable
          if(Constants.IS_REALTIME_REVIEW_STATUS_SYNC_ENABLED){
            syncReviewStatusInIntakePortal(e.statusId);
          }
        }
      });
  };

  const syncReviewStatusInIntakePortal = (statusId: any) => {
    httpService
      .post(ApiEndpoints.SyncProviderStatusWithIntake, {
        ProviderId: provider.providerId,
        StatusId: statusId,
        reviewerEmail: appUser?.email ?? appUser?.name,
        MpiId: provider.mpi,
      })
      .then((response: any) => {
        if (response.status === 200) {
          console.log("allStatues:", allStatues);
          console.log("syncReviewStatusInIntakePortal Response:", response);
        }
      });
  };

  // Fetch file information after file is uploaded
  useEffect(() => {
    if (fileUploaded) {
      //fetchSupportingFileInfo();
      setFileUploaded(false); // Reset after fetching
    }
  }, [fileUploaded]); // Triggers when a file is uploaded

  const fetchProviderDetails = async (mpi: number) => {
    httpService
      .get(`${ApiEndpoints.GetProviderDetails}/${reviewYear}/${mpi}`)
      .then((response: any) => {
        let _provider = response.data;
        console.log("Provider:", _provider);
        setSelectedProvider(_provider);
        setSelectedStatus(_provider.reviewStatus);
      })
      .catch((error: any) => {
        console.log("Error: ", error);
      })
      .finally(() => {
        // console.log('Finally');
      });
  };

  const fetchAllCommentsForProvider = async (providerId: string) => {
    httpService
      .post(ApiEndpoints.GetAllPfpCommentsForProvider, {
        commentLevel: commentLevel,
        providerMPI: providerId,
        measureId: commentMeasureId,
        reviewYear: reviewYear,
      })
      .then((response: any) => {
        if (response.status === 200) {
          setAllCommentData(response?.data);
        }
      })
      .catch((error: any) => {
        console.log("Error: ", error);
      })
      .finally(() => {
        // console.log('Finally');
      });
  };
 const updatePerformanceAreasStatus = (response: {
    reviewResponseId: number | null | undefined;
    performanceareaId: number;
    standardId: number;
    measureId: number;
    questionId: number;
    reviewResponse: string | null;
  }) => {
    if (performanceAreas.length > 0) {
      setPerformanceAreas((prevPerformanceAreas) =>
        prevPerformanceAreas.map((area) => ({
          ...area,
          standards: area.standards.map((standard) => ({
            ...standard,
            measures: standard.measures.map((measure) => {
              if (measure.measureId === response.measureId) {
                if (!response.questionId) {
                  // Update measure.isApproved
                  return { ...measure, reviewResponse: response.reviewResponse };
                } else {
                  // Update question.isReviewed
                  return {
                    ...measure,
                    questions: measure.questions.map((question) =>
                      question.questionId === response.questionId
                        ? { ...question, reviewResponse: response.reviewResponse }
                        : question
                    ),
                  };
                }
              }
              return measure; // No match, return the original measure
            }),
          })),
        }))
      );
    }
  };
  // handling tier response submission
  const onReviewChange = (response: {
    reviewResponseId: number | null | undefined;
    performanceareaId: number;
    standardId: number;
    measureId: number;
    questionId: number;
    reviewResponse: string;
  }) => {
    updatePerformanceAreasStatus(response);
    let reviewResponse = reviweResponses.find(
      (resp) =>
        resp.incentiveTypeId === response.measureId &&
        resp.questionId === response.questionId
    );
    //handling the response data
    if (reviewResponse) {
      reviewResponse.reviewResponse = response.reviewResponse;
    } else {
      const name = appUser?.name;
      reviweResponses.push({
        tierId: performanceAreas[0].standards[0].tierId,
        reviewResponseId: response.reviewResponseId,
        mpiId: provider.mpi,
        incentiveTypeId: response.measureId,
        questionId: response.questionId,
        reviewResponse: response.reviewResponse,
        reasons: null,
        userReason: null,
        reviewerName: name
      });
    }
    const requeredData = reviweResponses; //.filter(resp => resp.isApproved || resp.reviewResponseId);
    setReviewResponses(requeredData);
    saveReviewResponses();
  };


  const saveReviewResponses = () => {
    httpService
      .post(
        `${ApiEndpoints.SavePerformanceEvaluation}/${appliedTierId}/${provider.mpi}`,
        reviweResponses
      )
      .then((response) => {
        console.log("Review Response submitted successfully:", response);
      })
      .catch((error) => {
        console.error("Error submitting review response:", error);
      });
  };
  const calculateTier = () => {
    //if (reviweResponses.length > 0) {
    httpService
      .post(
        `${ApiEndpoints.SubmitPerformanceEvaluation}/${provider.providerId}/${appliedTierId}/${provider.mpi}?providerType=${Constants.RSKey}`,
        reviweResponses
      )
      .then((response) => {
        alert("Tier Calculated Successfully");
        window.location.reload();
        console.log("Review Response submitted successfully:", response);
      })
      .catch((error) => {
        alert("Error While calculating the Tier");
        console.error("Error submitting review response:", error);
      });
    //}
  };

  const getFilenameFromContentDisposition = (contentDisposition: string) => {
    if (!contentDisposition) {
      return "";
    }
    const matches = contentDisposition.match(
      /filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i
    );
    if (matches && matches[1]) {
      const decoded = decodeURIComponent(matches[1]);
      // Strip path separators and characters dangerous in HTML attributes;
      // control chars (charCode 0-31) removed via charCodeAt to avoid no-control-regex lint rule
      return decoded
        .replace(/[/\\?%*:|"<>]/g, "")
        .split("")
        .filter((c) => c.charCodeAt(0) > 31)
        .join("")
        .trim();
    }
    return "";
  };

  const downLoadProviderDataByDataSource = (dataSource: string) => {
    const safeMpi = String(provider.mpi);
    if (!safeMpi || isNaN(Number(safeMpi)) || Number(safeMpi) <= 0) {
      console.error("Invalid MPI value");
      return;
    }
    httpService
      .getBlob(
        `${ApiEndpoints.ExtractDataByDataSource}/${safeMpi}/${encodeURIComponent(dataSource)}?reviewYear=${encodeURIComponent(String(reviewYear))}`
      )
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        const contentDisposition =
          response.headers["content-disposition"] ?? "";
        link.setAttribute(
          "download",
          getFilenameFromContentDisposition(contentDisposition)
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error: any) => {
        setShowConfirmDialog(true);
        console.error("Error downloading provider data:", error);
      });
  };

  // Fetch performance areas, standards, measures, questions, and documents
  const fetchPerformanceStandardsMeasuresInfo = async (
    mpiId: number,
    providerAppliedTier: string
  ) => {
    try {
      setLoading(true);
      const response = await httpService.get<PerformanceArea[]>(
        `${ApiEndpoints.GetAllPerformanceStandardsMeasuresInfo}/${reviewYear}/${mpiId}?tierName=${providerAppliedTier}`
      );
      let tierData = groupDataByTier(response.data);
      let activeTierData = tierData.filter(
        (tier) =>
          tier.tierName?.toLowerCase() === providerAppliedTier?.toLowerCase()
      )[0];
      setPerformanceAreas(activeTierData.performanceAreas);
      setAppliedTierId(activeTierData.tierId);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching performance area info:", error);
      setLoading(false);
    }
  };

  const groupDataByTier = (data: any[]): TierQuestions[] => {
    // Object.create(null) prevents prototype pollution via __proto__ / constructor keys
    const tierMap: { [key: number]: TierQuestions } = Object.create(null);
    data.forEach((item) => {
      const {
        tierId,
        tierName,
        performanceAreaId,
        performanceAreaTitle,
        performanceAreaDescription,
        standardId,
        standardTitle,
        standardDescription,
        measureId,
        measureTitle,
        measureDescription,
        measureNumber,
        reviewResponse,
        reviewResponseId,
        isCalculatedField,
        questionId,
        questionTitle,
        questionDescription,
        isReviewed,
        fieldName,
        fieldValue,
        dataFieldType,
        dataSource,
        hasValidThreshold,
        questionSequence,
        questionNumber,
        propertySequence,
        displayConfig,
      } = item;

      // Validate tierId is a safe positive integer to prevent prototype pollution
      const safeTierId = Number(tierId);
      if (!Number.isFinite(safeTierId) || !Number.isInteger(safeTierId) || safeTierId <= 0) return;

      // If the tier doesn't exist, create it
      if (!tierMap[safeTierId]) {
        tierMap[safeTierId] = {
          tierId: safeTierId,
          tierName,
          performanceAreas: [],
        };
      }
      //
      // Add performance area to the tier
      if (!tierMap[safeTierId].performanceAreas) {
        tierMap[safeTierId].performanceAreas = [];
      }

      let performanceArea = tierMap[safeTierId].performanceAreas.find(
        (pa) => pa.performanceAreaId === performanceAreaId
      );
      if (!performanceArea) {
        performanceArea = {
          performanceAreaId,
          performanceAreaTitle,
          performanceAreaDescription,
          standards: [],
        };
        tierMap[safeTierId].performanceAreas.push(performanceArea);
      }

      // Add standard to the performance area
      let standard = performanceArea.standards.find(
        (s) => s.standardId === standardId
      );
      if (!standard) {
        standard = {
          standardId,
          standardTitle,
          standardDescription,
          isLocationSpecific: item.isLocationSpecific,
          tierId: safeTierId,
          tierName,
          measures: [],
        };
        performanceArea.standards.push(standard);
      }

      // Add measure to the standard
      let measure = standard.measures.find((m) => m.measureId == measureId);
      if (!measure) {
        const commentAvailable =
          allCommentData.filter((c) => c.measureId === measureId).length > 0;
        measure = {
          measureId,
          measureTitle,
          measureDescription,
          measureNumber,
          reviewResponse,
          reviewResponseId: reviewResponse ? reviewResponseId : null,
          questions: [],
          isCommentsAvailable: commentAvailable,
          hasReasons: false,//renamed
        };
        standard.measures.push(measure);
      }

      let question = measure.questions.find((q) => q.questionId === questionId);
      if (!question) {
        question = {
          questionId,
          questionTitle,
          questionDescription,
          questionSequence: questionSequence,
          questionNumber: questionNumber,
          dataFieldType,
          isReviewed,
          dataSource,
          reviewResponseId: isReviewed ? reviewResponseId : null,
          isCalculatedField,
          displayConfig: displayConfig
            ? JSON.parse(displayConfig)
            : displayConfig,
          responseData: [],
        };

        measure.questions.push(question);
      }

      question.responseData.push({
        fieldName,
        fieldValue,
        hasValidThreshold,
        propertySequence,
      });
    });
    return Object.values(tierMap);
  };

  const canDisable = () => {
   return (
      selectedStatus?.statusCode?.toLowerCase() ==
        ReviewStatusCode.NotStarted?.toLowerCase() ||
      provider?.reviewStatusId == 0 ||
      selectedStatus?.statusCode?.toLowerCase() ==
        ReviewStatusCode.ReviewCompleted?.toLowerCase()
    );
  };

  const renderStandardsSection = (standards: Standard[]) => {
    return (
      <>
        {standards
          .sort((a, b) => a?.standardTitle.localeCompare(b?.standardTitle))
          .map((standard: Standard) => (
            <StandardsDetailsComponent
              downLoadProviderDataByDataSource={
                downLoadProviderDataByDataSource
              }
              key={standard.standardTitle}
              isEnabled={isActiveReview && !canDisable()}
              standard={standard}
              onReviewChange={onReviewChange}
              updatePerformanceAreasForComments={
                updatePerformanceAreasForComments
              }
              providerAgencyName={provider?.providerAgencyName}
              evaluationStatuses={getAllEvaluationStatuses()}
              incentiveAmountCredentialing={0}
            />
          ))}
      </>
    );
  };

  const getPAStatus = (area: PerformanceArea) => {
    const allApproved = area.standards.every((standard) =>
      standard.measures.every((measure) => measure.reviewResponse != null)
    );

    const notStarted = area.standards.every((standard) =>
      standard.measures.every((measure) => measure.reviewResponse == null)
    );
    if (allApproved) {
      return "Completed";
    } else if (notStarted) {
      return "Not Started";
    } else {
      return "In-progress";
    }
  };

  const perfromanceAreaTabHeader = (area: PerformanceArea) => {
    const getIsCommentAvailable = (standards: Standard[]): boolean => {
      let isComments: boolean = false;
      standards.forEach((std) =>
        std.measures.forEach((measure) => {
          if (measure.isCommentsAvailable) {
            isComments = true;
          }
        })
      );
      return isComments;
    };
    return (
      <div className="d-flex">
        <div
          className="d-flex"
          style={{ flexGrow: "1", justifyContent: "space-between" }}
        >
          <Tooltip target={"#pa-" + area.performanceAreaId} />
          <div
            data-pr-tooltip={area.performanceAreaTitle}
            data-pr-position="left"
            data-pr-at="right top-20"
            data-pr-my="center"
            id={area.performanceAreaId.toString()}
            className={""}
          >
            <div
              style={{
                display: "inline-block",
                maxWidth: "100ch",
                lineHeight: "2",
                textOverflow: "ellipsis",
              }}
            >
              {area.performanceAreaTitle}
              {": "}
              {area.performanceAreaDescription}
            </div>
          </div>
          {getPAStatus(area) === "Completed" ? (
            <Badge severity="success" className="right" value="Completed" />
          ) : getPAStatus(area) === "Not Started" ? (
            <Badge severity="info" className="right" value="Not Started" />
          ) : (
            <Badge severity="warning" className="right" value="In Progress" />
          )}
        </div>
        <div>
          {getIsCommentAvailable(area.standards) ? (
            <i
              className={"pi pi-comments"}
              style={{ width: "20px", paddingTop: "5px" }}
            ></i>
          ) : (
            <i className="pi" style={{ width: "20px", paddingTop: "5px" }}></i>
          )}
        </div>
      </div>
    );
  };

  const getApprovalPercentage = () => {
    const totalMeasures = performanceAreas.reduce((acc, area) => {
      return (
        acc +
        area.standards.reduce((acc, standard) => {
          return acc + standard.measures.length;
        }, 0)
      );
    }, 0);

    const approvedMeasures = performanceAreas.reduce((acc, area) => {
      return (
        acc +
        area.standards.reduce((acc, standard) => {
          return (
            acc +
            standard.measures.filter((measure) => measure.reviewResponse).length
          );
        }, 0)
      );
    }, 0);

    const approvalPercentage =
      totalMeasures > 0 ? (approvedMeasures / totalMeasures) * 100 : 0;
    return `${approvalPercentage.toFixed(2)}% Approved`;
  };
  // Main Accordion for Performance Areas
  const renderPerformanceAreasAccordion = () => {
    return (
      <>
        <div>
          <h3>
            <span className="section-title">Performance Evaluation</span>
            <Badge
              value={getApprovalPercentage()}
              severity={
                getApprovalPercentage()?.includes("100") ? "success" : "info"
              }
              className="ml-2"
            />
          </h3>
          <Accordion>
            {performanceAreas
              .sort((a, b) =>
                alphaNumericSort(
                  a.performanceAreaTitle,
                  b?.performanceAreaTitle
                )
              )
              .map((area) => (
                <AccordionTab
                  key={area.performanceAreaTitle}
                  header={perfromanceAreaTabHeader(area)}
                >
                  {renderStandardsSection(area.standards)}
                </AccordionTab>
              ))}
          </Accordion>
        </div>
        <div className="tier-action-section">
          <Button
            className="p-button-secondary"
            label="Calculate Tier"
            onClick={() => calculateTier()}
            disabled={hasUnReviewedMeasures() || !isActiveReview || canDisable()}
          />
        </div>
      </>
    );
  };

  // Callback function for successful file upload
  const handleUploadSuccess = () => {
    setUploadStatus("File uploaded successfully");
    setFileUploaded(true); // Trigger file upload state change
  };

  const renderTierView = () => {
    return (
      <div className="tier-view-accordion">
        {loading ? (
          <p>Loading performance areas...</p>
        ) : (
          renderPerformanceAreasAccordion()
        )}
      </div>
    );
  };

  const downloadDataFile = (fileName: any, providerId: any) => {
    const safeProviderId = Number(providerId);
    if (!safeProviderId || !Number.isInteger(safeProviderId) || safeProviderId <= 0) {
      console.error("Invalid provider ID");
      return;
    }
    httpService
      .get(
        `${ApiEndpoints.DownloadSupportingDataFile}/${safeProviderId}/${encodeURIComponent(String(fileName))}?reviewYear=${encodeURIComponent(String(reviewYear))}`
      )
      .then((response: any) => {
        if (response) {
          console.log("response", response);
          let url = response.data.url;
          const validatedUrl = new URL(url);
          if (
            validatedUrl.protocol === "http:" ||
            validatedUrl.protocol === "https:"
          ) {
            const anchor = document.createElement("a");
            anchor.href = validatedUrl.toString();
            anchor.target = "_blank";
            anchor.click();
          }
        }
      })
      .catch((error: any) => {
        console.log("Error: ", error);
        setShowConfirmDialog(true);
      })
      .finally(() => {
        //setShowConfirmDialog(false);
      });
  };
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const hideDialog = () => {
    setShowConfirmDialog(false);
  };

  return (
    <div className="provider-profile-file-upload">
      <div style={{ display: "flex" }}>
        <div style={{ display: "flex", marginBottom: "20px", gap: "15px" }}>
          <>
            <span className="tag-key">Provider Name :</span>
            <span className="tag-value"> {provider?.providerAgencyName}</span>
          </>
          <>
            <span className="tag-key">MPI : </span>
            <span className="tag-value"> {provider.mpi}</span>
          </>
          <>
            <span className="tag-key">Tier : </span>
            <span className="tag-value"> {provider.currentTier}</span>
          </>

          {status.length > 0 && (
            <Dropdown
              disabled={!isActiveReview}
              value={selectedStatus}
              onChange={(e: DropdownChangeEvent) => setReviewStatus(e.value)}
              options={status}
              optionLabel="statusName"
              placeholder={provider.reviewStatus}
            />
          )}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginLeft: "auto",
          }}
        >
          <Button
            size="small"
            className="p-button-secondary"
            disabled={!isActiveReview}
            onClick={() => setSidebarVisible(!sidebarVisible)}
            style={{ marginRight: "15px" }}
          >
            Comment
          </Button>
          <Button
            size="small"
            className="p-button-secondary"
            onClick={() => setVisible(true)}
            style={{ marginRight: "15px" }}
          >
            Upload File
          </Button>
        </div>
      </div>
      <Dialog
        header="Upload"
        visible={visible}
        onHide={() => setVisible(false)}
      >
        <div
          className="flex flex-column px-8 py-5 gap-4"
          style={{
            borderRadius: "12px",
            width: "1000px",
            height: "auto",
            minHeight: "300px",
          }}
        >
          {provider.providerId && (
            <MultipartFileUploadComponent
              name="file"
              customUpload
              accept=".pdf,.doc,.docx"
              maxFileSize={1000000}
              auto
              chooseLabel="Choose"
              uploadLabel="Upload"
              cancelLabel="Cancel"
              className="p-mb-3"
              onFileuploaded={() => {
                console.log("file uploaded");
              }}
              providerId={provider.mpi}
              providerProfile="ProviderProfile"
              onUpload={handleUploadSuccess}
              onError={() => {
                setUploadStatus("Upload failed. Please try again.");
              }}
            />
          )}
          {uploadStatus && <p>{uploadStatus}</p>}
        </div>
      </Dialog>

      <div>
        <h3>
          <span className="section-title">Provider Information</span>
        </h3>
        {loading ? (
          <p>Loading provider details...</p>
        ) : (
          <DataTable value={[provider]} paginator={false}>
            <Column field="firstName" header="First Name" />
            <Column field="lastName" header="Last Name" />
            <Column field="telephoneNumber" header="Telephone Number" />
            <Column
              field="emailAddress"
              header="Email Address"
              body={(rowData) => (
                <a href={`mailto:${rowData.emailAddress}`}>
                  {rowData.emailAddress}
                </a>
              )}
            />
            <Column field="appliedTier" header="Tier Applying For" />
            {/* <Column field="attestationDoc" header="Attestation Document" 
                            body={() => (
                                attestationFile && attestationFile.fileName
                                ? <a onClick={()=>{setShowConfirmDialog(true)}} style={{color: "-webkit-link",
                                    cursor: "pointer",
                                    textDecoration: "underline"}}>Download File</a> 
                                : <></>
                            )}
                        /> */}
          </DataTable>
        )}
      </div>
      {provider.attestationFile ? (
        <div className="attestation-button-wrapper">
          <Button
            onClick={() => {
              downloadDataFile(provider.attestationFile, provider?.mpi);
            }}
            icon="pi pi-download"
            className="p-button-secondary"
          >
            &nbsp;{provider.attestationFile}
            {/*"Download Attestation File"*/}
          </Button>
        </div>
      ) : (
        <></>
      )}
      <div>{renderTierView()}</div>
      <Dialog
        header="File not found!"
        visible={showConfirmDialog}
        onHide={hideDialog}
        footer={
          <div style={{ display: "flex", justifyContent: "end" }}>
            <Button
              label="Close"
              icon="pi pi-times"
              className="p-button-secondary"
              onClick={hideDialog}
              autoFocus
            />
          </div>
        }
      >
        <div>
          <p>{Constants.FILE_NOT_FOUND_ERROR}</p>
        </div>
      </Dialog>
      {sidebarVisible && (
        <CommentsSidebar
          {...{
            sidebarVisible,
            setSidebarVisible,
            commentProviderMPI,
            commentMeasureId,
            commentMeasureNumber,
            commentLevel,
            updatePerformanceAreasForComments,
            providerAgencyName:provider?.providerAgencyName
          }}
        />
      )}
    </div>
  );
};

export default PfpRHProviderProfileComponent;
